import React from "react";
import { history } from "../store";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchMachines, updateMachineTPV } from "../actions/machines";

import MachineStatusBadge from "./MachineStatusBadge";
import MachineCashBadge from "./MachineCashBadge";

class TPVList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: {}, // map of "Serial_field" => boolean
      inputs: {}, // map of "Serial_field" => input value
    };
  }

  startEditing = (serial, field, currentValue) => {
    const key = `${serial}_${field}`;
    this.setState((prev) => ({
      editing: { ...prev.editing, [key]: true },
      inputs: { ...prev.inputs, [key]: currentValue },
    }));
  };

  cancelEditing = (serial, field) => {
    const key = `${serial}_${field}`;
    this.setState((prev) => ({
      editing: { ...prev.editing, [key]: false },
      inputs: { ...prev.inputs, [key]: "" },
    }));
  };

  handleInputChange = (serial, field, value) => {
    const key = `${serial}_${field}`;
    this.setState((prev) => ({
      inputs: { ...prev.inputs, [key]: value },
    }));
  };

  handleSave = async (serial, machineId, field) => {
    const key = `${serial}_${field}`;
    const { inputs } = this.state;
    const { updateMachineTPV, fetchMachines } = this.props;

    const newValue = inputs[key];

    const response = await updateMachineTPV(machineId, { [field]: newValue });

    if (!response.error) {
      if (typeof fetchMachines === "function") {
        fetchMachines();
      }

      this.setState((prev) => ({
        editing: { ...prev.editing, [key]: false },
      }));
    } else {
      alert(`Error actualizando el campo ${field}`);
    }
  };

  goTo(Serial, e) {
    history.push(`/machines/${Serial}`);
  }

  getTPVPresent(machine) {
    if (!machine.PaymentDevices) return false;
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && machine.Tpv_serial) {
        return true;
      }
    }
  }

  generateTpvPassFromSerial(sn) {
    if (!sn || sn.length < 8) return null; // sanity check

    // build pass as: 8th digit + 3rd + 4th + 6th + 7th + last
    const digits = sn.split("");
    return (
      digits[7] + // 8th
      digits[2] + // 3rd
      digits[3] + // 4th
      digits[5] + // 6th
      digits[6] + // 7th
      digits[digits.length - 1] // last
    );
  }

  getDeviceModel(machine) {
    if (!machine.PaymentDevices) return <span>NO DEVICE</span>;
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];
      if (
        device.Type === "TPV" &&
        (device.Device === "PAYTEF" || device.Device === "SPIRE")
      ) {
        return <span>SPu90</span>;
      } else if (device.Type === "TPV") {
        return <span>{device.Device}</span>;
      } else {
        return <span>NO DEVICE</span>;
      }
    }

    return <span>NO DEVICE</span>;
  }

  getPlatform(machine) {
    if (!machine.PaymentDevices) return null;
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];
      if (device.Type === "TPV" && device.Device === "PAYTEF") {
        return <span>{device.Device}</span>;
      } else if (device.Type === "TPV" && device.Device === "Q5000") {
        return <span>WIPAY</span>;
      } else if (device.Type === "TPV" && device.Device === "Q6000") {
        return <span>COMERCIA</span>;
      } else if (device.Type === "TPV") {
        return <span>REDSYS</span>;
      }
    }
  }

  getDeviceType(machine) {
    if (!machine.PaymentDevices) return false;
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && device.Device != "PAYTEF") {
        return true;
      }
    }
  }

  getMerchantCode(machine) {
    if (!machine.PaymentDevices) return false;
    for (let i = 0; i < machine.PaymentDevices.length; i++) {
      const device = machine.PaymentDevices[i];

      if (device.Type == "TPV" && device.Device === "PAYTEF") {
        return true;
      }
    }
  }

  render() {
    const cardStyle = {
      background: '#fff',
      border: '1px solid #e4eaf2',
      borderRadius: 12,
      boxShadow: '0 1px 5px rgba(10,64,128,0.07)',
      overflow: 'hidden',
    };

    const thStyle = {
      padding: '10px 14px',
      fontSize: 11,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      color: '#5a6a85',
      background: '#f5f7fa',
      borderBottom: '1px solid #e4eaf2',
      whiteSpace: 'nowrap',
    };

    const tdStyle = {
      padding: '10px 14px',
      fontSize: 13,
      color: '#2d3a4e',
      borderBottom: '1px solid #f0f3f8',
      verticalAlign: 'middle',
    };

    const tdMonoStyle = {
      ...tdStyle,
      fontFamily: 'monospace',
      fontSize: 12,
    };

    const badgeDangerStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      padding: '3px 8px',
      borderRadius: 20,
      background: 'rgba(220,53,69,0.1)',
      color: '#dc3545',
      fontSize: 11,
      fontWeight: 600,
    };

    return (
      <div style={cardStyle}>
        <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={thStyle}>Máquina</th>
              <th style={thStyle}>Cliente</th>
              <th style={thStyle}>Modelo</th>
              <th style={thStyle}>Plataforma</th>
              <th style={thStyle}>SN</th>
              <th style={thStyle}>Pass</th>
              <th style={thStyle}>C. Comercio</th>
              <th style={thStyle}>TCOD</th>
              <th style={thStyle}>Clave Firma</th>
              <th style={thStyle}>Terminal</th>
            </tr>
          </thead>
          <tbody>
            {this.props.machines.map((machine) => {
              const hasQ6000 = machine.PaymentDevices?.some(
                (d) => d.Type === "TPV" && d.Device === "Q6000"
              );

              let displayPass = machine.Tpv_pass;
              let isAutogenerated = false;

              if (!displayPass && hasQ6000 && machine.Tpv_serial) {
                displayPass = this.generateTpvPassFromSerial(
                  machine.Tpv_serial
                );
                isAutogenerated = true;
              }

              const noTPV = !this.getTPVPresent(machine);

              const rowStyle = noTPV
                ? { background: 'rgba(220,53,69,0.04)' }
                : {};

              return (
                <tr key={machine.Serial} style={rowStyle}>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>
                    {noTPV ? (
                      <span style={badgeDangerStyle}>
                        <i className="fas fa-exclamation-circle" style={{ fontSize: 11 }} />
                        {machine.Serial}
                      </span>
                    ) : (
                      machine.Serial
                    )}
                  </td>
                  <td style={tdStyle}>
                    {(machine.Customer && machine.Customer.Fullname) || <span style={{ color: '#aab' }}>—</span>}
                  </td>
                  <td style={tdStyle}>{this.getDeviceModel(machine)}</td>
                  <td style={tdStyle}>{this.getPlatform(machine)}</td>

                  {/* SN editable field */}
                  <td style={tdMonoStyle}>
                    {this.state.editing[`${machine.Serial}_Tpv_serial`] ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <input
                          style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #c5cfe0', fontSize: 12, fontFamily: 'monospace', width: 120 }}
                          value={this.state.inputs[`${machine.Serial}_Tpv_serial`] || ""}
                          onChange={(e) => this.handleInputChange(machine.Serial, "Tpv_serial", e.target.value)}
                        />
                        <button
                          style={{ padding: '4px 8px', borderRadius: 6, border: 'none', background: '#27ae60', color: '#fff', cursor: 'pointer', fontSize: 12 }}
                          onClick={() => this.handleSave(machine.Serial, machine._id, "Tpv_serial")}
                        >
                          <i className="fas fa-check" />
                        </button>
                        <button
                          style={{ padding: '4px 8px', borderRadius: 6, border: 'none', background: '#8a9ab5', color: '#fff', cursor: 'pointer', fontSize: 12 }}
                          onClick={() => this.cancelEditing(machine.Serial, "Tpv_serial")}
                        >
                          <i className="fas fa-times" />
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span>{machine.Tpv_serial || <span style={{ color: '#aab' }}>—</span>}</span>
                        <button
                          style={{ padding: '3px 7px', borderRadius: 6, border: '1px solid #e4eaf2', background: '#fff', color: '#f59e0b', cursor: 'pointer', fontSize: 11, lineHeight: 1 }}
                          onClick={() => this.startEditing(machine.Serial, "Tpv_serial", machine.Tpv_serial)}
                        >
                          <i className="fas fa-edit" />
                        </button>
                      </div>
                    )}
                  </td>

                  {/* Pass editable field */}
                  <td style={tdMonoStyle}>
                    {this.state.editing[`${machine.Serial}_Tpv_pass`] ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <input
                          style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #c5cfe0', fontSize: 12, fontFamily: 'monospace', width: 120 }}
                          value={this.state.inputs[`${machine.Serial}_Tpv_pass`] || ""}
                          onChange={(e) => this.handleInputChange(machine.Serial, "Tpv_pass", e.target.value)}
                        />
                        <button
                          style={{ padding: '4px 8px', borderRadius: 6, border: 'none', background: '#27ae60', color: '#fff', cursor: 'pointer', fontSize: 12 }}
                          onClick={() => this.handleSave(machine.Serial, machine._id, "Tpv_pass")}
                        >
                          <i className="fas fa-check" />
                        </button>
                        <button
                          style={{ padding: '4px 8px', borderRadius: 6, border: 'none', background: '#8a9ab5', color: '#fff', cursor: 'pointer', fontSize: 12 }}
                          onClick={() => this.cancelEditing(machine.Serial, "Tpv_pass")}
                        >
                          <i className="fas fa-times" />
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        {isAutogenerated ? (
                          <span style={{ color: '#f59e0b', fontStyle: 'italic' }}>
                            {displayPass} <small style={{ fontSize: 10, opacity: 0.7 }}>(auto)</small>
                          </span>
                        ) : (
                          <span>{displayPass || <span style={{ color: '#aab' }}>—</span>}</span>
                        )}
                        <button
                          style={{ padding: '3px 7px', borderRadius: 6, border: '1px solid #e4eaf2', background: '#fff', color: '#f59e0b', cursor: 'pointer', fontSize: 11, lineHeight: 1 }}
                          onClick={() => this.startEditing(machine.Serial, "Tpv_pass", machine.Tpv_pass)}
                        >
                          <i className="fas fa-edit" />
                        </button>
                      </div>
                    )}
                  </td>

                  <td style={tdMonoStyle}>
                    {this.getDeviceType(machine) ? machine.TpvBusinessCode || <span style={{ color: '#aab' }}>—</span> : <span style={{ color: '#aab' }}>—</span>}
                  </td>
                  <td style={tdMonoStyle}>
                    {this.getMerchantCode(machine) ? machine.Tpv_tcod || <span style={{ color: '#aab' }}>—</span> : <span style={{ color: '#aab' }}>—</span>}
                  </td>
                  <td style={tdMonoStyle}>
                    {this.getDeviceType(machine) ? machine.TpvFirmKeyCode || <span style={{ color: '#aab' }}>—</span> : <span style={{ color: '#aab' }}>—</span>}
                  </td>
                  <td style={tdMonoStyle}>
                    {this.getDeviceType(machine) ? machine.TpvTerminalCode || <span style={{ color: '#aab' }}>—</span> : <span style={{ color: '#aab' }}>—</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  updateMachineTPV: bindActionCreators(updateMachineTPV, dispatch),
});

export default connect(null, mapDispatchToProps)(TPVList);
